<template>
  <div>
    <div class="p-menu-store-info">

        <iframe
            width="70%"
            height="400px"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            :src="`https://www.google.com/maps/embed/v1/place?key=${googleMapApiKey}&q=${store.latitude},${store.longitude}&center=${store.latitude + mapCenter},${store.longitude}`"
              >
        </iframe>

        <div class="p-menu-store-info__link">
          <a
            @click="openGoogleMap()" target="_blank"
            class="c-text-button c-text-button--sm c-text-button--right"
          >
            GoogleMap で見る
            <Icon
              name="arrow_right"
              width="33px"
              height="48px"
              :color="'#DA291C'"
            />
          </a>
        </div>
      <div class="p-menu-store-info__contents">
        <MenusLabelList :list="storeData" />
      </div>
    </div>
  </div>
</template>

<script>
import MenusLabelList from '../MenusLabelList'
export default {
  components: {
    MenusLabelList,
  },
  props: {
    store: {
      type: Object,
      default: () => ({})
    },
    menu: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      googleMapApiKey: process.env.VUE_APP_MAP_GOOGLE_API_KEY,
      innerWidth: window.innerWidth
    };
  },
  computed: {
    storeData() {
      let list = [];
      const facilities = this.store;
      if (!this.store) return list;
      if (facilities.facilityNm) {
        list.push({ label: "店舗名", type: 1, name: facilities.facilityNm });
      }
      if (facilities.zipCode) {
        list.push({
          label: "住所",
          type: 1,
          name:
            "〒" +
            this.$utils.formatZipcode(facilities.zipCode) +
            "　" +
            this.prefecturesName +
            facilities.facilityAddress
        });
      }
      if (facilities.access) {
        list.push({
          label: "アクセス",
          type: 1,
          name: facilities.access
        });
      }
      if (facilities.openingHours) {
        list.push({ label: "営業時間", type: 3, ary: facilities.openingHours });
      }
      if (facilities.regularlyCloseds) {
        list.push({
          label: "定休日",
          type: 1,
          name: facilities.regularlyCloseds.join("、")
        });
      }
      if (facilities.facilityTelNo) {
        list.push({ label: "TEL", type: 1, name: facilities.facilityTelNo });
      }
      if (facilities.facilityFax) {
        list.push({ label: "FAX", type: 1, name: facilities.facilityFax });
      }
      if (facilities.facilityEmail) {
        list.push({ label: "メール", type: 1, name: facilities.facilityEmail });
      }
      if (facilities.facilityInqForm) {
        list.push({
          label: "お問い合わせ",
          type: 2,
          name: "提供企業お問い合わせフォーム",
          url: facilities.facilityInqForm
        });
      }
      if (facilities.facilityUrl) {
        list.push({
          label: "URL",
          type: 4,
          name: facilities.facilityUrl,
          url: facilities.facilityUrl
        });
      }
      if (facilities.note) {
        list.push({ label: "備考", type: 1, name: facilities.note });
      }
      return list;
    },
    prefecturesName() {
      if (
        !this.$pref.codes[this.store.pref] ||
        !this.$pref.codes[this.store.pref].name
      ) {
        return "";
      }
      return this.$pref.codes[this.store.pref].name;
    },
    mapCoordinate() {
      if (!this.store || (!this.store.latitude && !this.store.longitude)) {
        return {};
      }
      return this.$maps.mapsUrl(this.store.latitude, this.store.longitude);
    },
    mapImage() {
      const parentCategory = this.$mapIcons.getIconCode(
        this.menu.catLrgClassCd
      );
      if (!this.store || (!this.store.latitude && !this.store.longitude)) {
        return {};
      }
      return this.$maps.mapsImage(
        this.store.latitude,
        this.store.longitude,
        parentCategory.iconNo
      );
    },
    /**
     * @return { Number } Google Map pin position adjustment (latitude)
     * @see {@link https://developers.google.com/maps/documentation/embed/embedding-map? hl=yes}
     */
    mapCenter () {
      return this.innerWidth > 768 ? 0.0006 : this.innerWidth > 440 ? 0.0013 : 0.0009
    }
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    });
  },
  methods: {
    openGoogleMap() {
      if (this.store.latitude && this.store.longitude) {
        window.open(`https://maps.google.com/?q=${this.store.latitude},${this.store.longitude}`)
      } else {
        window.open('https://maps.google.com')
      }
    },
    onResize() {
      this.innerWidth = window.innerWidth
    }
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  }
};
</script>

<style lang="scss" scoped>
@import './style.scss';
.c-text-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  background-color: transparent;
  color: #1f2021;
  vertical-align: middle;
  cursor: pointer;
  &:active {
    transform: translate(0, 1px);
  }
  &:hover {
    color: #da291c;
    text-decoration: none;
    @include mq() {
      color: #1f2021;
    }
    g {
      fill: #da291c;
    }
  }
  .c-icon {
    &:first-of-type {
      position: absolute;
      top: 50%;
      // margin-top: -0.575em;
      width: 1.325em;
      height: 1.325em;
    }
    &:not(:first-of-type) {
      margin-right: 0.25em;
      margin-left: 0.25em;
    }
  }
  &--sm {
    font-size: 0.875rem;
  }
  &--right {
    padding-right: 1.75em;
    .c-icon {
      right: 0;
    }
  }
  &--left {
    padding-left: 1.75em;
    .c-icon {
      left: 0;
    }
  }
  &--color1 {
    .c-icon {
      fill: #da291c;
    }
  }
}
</style>
